const inFlight = new Map<string, Promise<unknown>>();

export const coalesce = <TResult>(
  key: string,
  fn: () => Promise<TResult>,
): Promise<TResult> => {
  const existing = inFlight.get(key);
  if (existing) {
    return existing as Promise<TResult>;
  }

  const promise = fn().finally(() => {
    inFlight.delete(key);
  });

  inFlight.set(key, promise);
  return promise;
};
